import {useQuery} from "@tanstack/react-query";

import {safelistingsService} from "../services";

export default function useSafelisting(id: number | null) {
  const {data, ...query} = useQuery({
    queryKey: ["safelisting", id],
    queryFn: () => (id ? safelistingsService.getSafelisting(id) : Promise.resolve(null)),
    enabled: Boolean(id),
  });

  const safelisting = query.isSuccess ? data : null;
  const isPending = Boolean(id) && query.isPending;

  return {
    ...query,
    safelisting,
    isPending,
  };
}
